import { ApiUrls } from "../types/enums";
import { DEFAULT_CULTURE, DEFAULT_TERMINAL } from "../shared/constants";

export const PlaceBetSport = async ({
  config,
  acceptOddsChanges,
  bookingCode,
  authorizationKey,
  selections,
  rows,
  bonusIds,
  totalStake,
  isBooking,
  BetBuilderModel,
}: PlaceBetSportPayload): Promise<PlaceBetSportResponse> => {
  const response = await fetch(ApiUrls.PLACE_BET_SPORT, {
    method: "POST",
    headers: {
      brandid: config.brandId,
      channelid: config.channelId,
      terminal: config.terminal || DEFAULT_TERMINAL,
      language: config.language || DEFAULT_CULTURE,
      "content-type": "application/json",
      ...(config.userToken
        ? {
            token: config.userToken,
            authorization: `Bearer ${config.userToken}`,
          }
        : {}),
      ...(isBooking && config.userToken ? { userToken: config.userToken } : {}),
    },
    body: JSON.stringify({
      language: config.language || DEFAULT_CULTURE,
      acceptOddsChanges,
      ...(config.userToken ? { userToken: config.userToken } : {}),
      ...(bookingCode ? { bookingCode } : {}),
      selections,
      rows,
      bonusIds,
      totalStake,
      isBooking,
      BetBuilderModel,
      ...(authorizationKey ? { authorizationKey } : {}), // Only include if provided
    }),
  });
  return response.json();
};
